import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-auth',
  template: '<router-outlet/>',
  imports: [RouterModule],
})
export class AuthRouterComponent { }
